import { createContext, use } from "react";

export type MediaStatus = "loading" | "loaded" | "error";

export interface IMediaPreviewState {
    status: MediaStatus;
    isPlaying: boolean;
    duration: number | null;
}

export interface IMediaPreviewActions {
    setLoaded: () => void;
    setError: () => void;
    setPlaying: (playing: boolean) => void;
    setDuration: (duration: number | null) => void;
}

export interface IMediaPreviewContextValue {
    state: IMediaPreviewState;
    actions: IMediaPreviewActions;
}

export const MediaPreviewContext = createContext<IMediaPreviewContextValue | null>(null);

export const useMediaPreviewContext = () => {
    const context = use(MediaPreviewContext);
    if (!context) {
        throw new Error("useMediaPreviewContext must be used within a MediaPreview.Provider");
    }
    return context;
};

/**
 * Non-throwing variant for components (e.g. SocialAdCard) rendered both inside
 * a MediaPreview.Provider (modal) and standalone (gallery grid). Returns null
 * when no provider is present.
 */
export const useMediaPreviewContextOptional = (): IMediaPreviewContextValue | null => use(MediaPreviewContext);
